/**
 * These are essentially just the routes in the confirm completion funnel.  Ember 2.14 does not have an easy way to
 * access, so just using this for now.
 *
 * @type {Object}
 */
export const PROJECT_COMPLETION__SUB_VIEWS = {
  NONE: 'none',
  PRIVATE_FEEDBACK: 'private-feedback',
  PUBLIC_FEEDBACK: 'public-feedback',
};

const PROJECT_COMPLETION__APPLICATION_INCLUDES = [
  'buyer',
  'buyer.company',
  'seller',
  'project-line-items',
  'fee-structure',
  'location',
  'services',
  'sh-payments',
  'sh-payments.expedite-requestor',
  'sh-payments.expedite-requestor.company',
];

export function getProjectCompletionApplicationIncludes(user) {
  // would mutate on subsequent calls without this!
  const includes = Object.assign([], PROJECT_COMPLETION__APPLICATION_INCLUDES);

  if (user.isBuyer || user.isAdmin) {
    includes.push('cost-code');
    includes.push('buyer.company.default-cost-code');
  }

  return includes;
}

